import { get, patch } from './base'

export const getUser = () => get({ path: 'user' })

export const updateUserLanguage = language =>
  patch({
    path: 'user',
    params: { language: language },
  })
